import { render } from "./Product_List_Item.vue?vue&type=template&id=27683038&scoped=true"
import script from "./Product_List_Item.vue?vue&type=script&lang=js"
export * from "./Product_List_Item.vue?vue&type=script&lang=js"

import "./Product_List_Item.vue?vue&type=style&index=0&id=27683038&scoped=true&lang=css"

import exportComponent from "D:\\DockerProjects\\armt_pos_v2_docker\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27683038"]])

export default __exports__